import { createReducer, createActions } from 'reduxsauce'
import {
  initialFeedback,
  requestFeedback,
  successFeedback,
  failureFeedback,
} from 'reducers/utils'

/**
 * The advisor's own deals in EVERY state (`/v1/crm/deals/`, unpaginated
 * array) — the base of "Mis cierres" (LOCK r4): open deals feed the
 * "En validación" zone; registered/paid/canceled states join in from the
 * closed-deals and my_deals sources at build time.
 */
const INITIAL_STATE = {
  deals: [],
  dealsFeedback: initialFeedback(),
}

const { Types, Creators } = createActions(
  {
    getAdvisorDealsRequest: ['params'],
    getAdvisorDealsSuccess: ['deals'],
    getAdvisorDealsFailure: ['errors'],
  },
  { prefix: 'ADVISOR_DEALS_' },
)

const HANDLERS = {
  [Types.GET_ADVISOR_DEALS_REQUEST]: state => ({
    ...state,
    dealsFeedback: requestFeedback(),
  }),
  [Types.GET_ADVISOR_DEALS_SUCCESS]: (state, { deals }) => ({
    ...state,
    deals,
    dealsFeedback: successFeedback(),
  }),
  [Types.GET_ADVISOR_DEALS_FAILURE]: (state, { errors }) => ({
    ...state,
    dealsFeedback: failureFeedback(errors),
  }),
}

export const AdvisorDealsActionTypes = Types
export const AdvisorDealsActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
